import styled from 'styled-components'
import Text from 'components/shared/Text'
import { shouldForwardProp } from 'helpers'

interface StyledHighlightedTextProps {
    hasFullLineTexts?: boolean
}

export const StyledHighlightedText = styled(Text).withConfig({
    shouldForwardProp: (prop) =>
        shouldForwardProp<StyledHighlightedTextProps>(
            ['hasFullLineTexts'],
            prop
        ),
})<StyledHighlightedTextProps>`
    display: ${({ hasFullLineTexts }) =>
        hasFullLineTexts ? 'block' : 'inline'};
`
